export default __webpack_public_path__ + "static/media/booking2.58235ac8.png";